<template>
  <section class="content">
    <div class="columns is-mobile">
      <div class="column is-narrow">
        <svg-icon icon="success" class="icon is-large"/>
      </div>
      <div v-if="$route.params.status === 'completed'" class="column">
        <h2 class="is-marginless">{{ 'success' | term }}</h2>
        <span>{{ 'case_completed_on' | term }} </span>
        <span class="has-text-success has-text-weight-bold">{{ mycase.modified | dateFormat }}</span>
      </div>
      <div v-else-if="$route.params.status !== 'completed'">
        <h2 class="is-marginless">{{ mycase.status }}</h2>
        <span>{{ 'uploaded' | term }} </span>
        <span class="has-text-success has-text-weight-bold">{{ mycase.modified | dateFormat }}</span>
      </div>
      <div v-else>
        <h2 class="is-marginless">Case unknown</h2>
        <span class="has-text-grey has-text-weight-bold">Case not found</span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'caseStatus',
  components: {
    SvgIcon
  },
  computed: {
    ...mapState([
      'mycase'
    ])
  }
}
</script>
